export default function (el, handler) {
  let target, startx, starty
  function handleMouseDown(e) {
    target = e.target
    startx = e.clientX
    starty = e.clientY
  }

  function handleMouseMove(e) {
    if (Math.max(
      Math.abs(e.clientX - startx),
      Math.abs(e.clientY - starty)
    ) > 5)
      target = null
  }

  function handleMouseUp(e) {
    if (target === e.target) {
      handler(e)
    }
  }

  el.addEventListener("mousedown", handleMouseDown, false)
  el.addEventListener("mousemove", handleMouseMove, false)
  el.addEventListener("mouseup", handleMouseUp, false)

  return function () {
    el.removeEventListener("mousedown", handleMouseDown, false)
    el.removeEventListener("mousemove", handleMouseMove, false)
    el.removeEventListener("mouseup", handleMouseUp, false)
  }
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/strictClick/index.js